import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useSearchParams } from 'react-router-dom';
import { postMAIAA010 } from '../../../services/Api';
import CheckGroup from '../../../shared/components/CheckGroup';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_PAYMENT } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';
import MAIAA020 from './popupMAIAA020';
import MAIAA030 from './popupMAIAA030';
const MAIAA010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchCondition, setSearchCondition] = useState('DE_MemberID');
    const [selectDateCondition, setSelectDateCondition] = useState('UseDate');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [checkedValues, setCheckedValues] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [updateData, setUpdateData] = useState({});
    const [activePopup, setActivePopup] = useState(false);

    const getSearchCondition = (e) => {
        setSearchCondition(e.target.value);
    };
    const getSearchDateCondition = (e) => {
        setSelectDateCondition(e.target.value);
    };
    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        postMAIAA010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            searchDateBy: selectDateCondition,
            startDate: startDateFormated,
            endDate: endDateFormated,
            options: checkedValues,
            size: 20,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const clickReset = () => {
        setSearchParams('');
        setStartDate('');
        setEndDate('');
        setDateRate('');
        setKeyword('');
        setSearchCondition('DE_MemberID');
        setSelectDateCondition('UseDate');
        setCheckedValues({});
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, isPopupOpen]);

    // const handleCheckboxChange = (e) => {
    //     const { name, value, checked } = e.target;
    //     setCheckedValues((checkedValues) => getCheckBoxValues(checkedValues, name, value, checked));
    // };
    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;

        setCheckedValues((prev) => {
            let newValues = [...(prev[name] || [])];

            if (checked) {
                if (value === 'ALL') {
                    newValues = ['ALL'];
                } else {
                    newValues = newValues.filter((v) => v !== 'ALL');
                    if (!newValues.includes(value)) newValues.push(value);
                }
            } else {
                newValues = newValues.filter((v) => v !== value);
            }

            return { ...prev, [name]: newValues };
        });
    };


    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setUpdateData({});
    };

    const handleActivePopup = () => {
        setActivePopup(true);
    };

    const handleClosePopup = () => {
        setActivePopup(false);
    };

    const showPopupUpdate = (seq) => {
        const filterData = data.filter((item) => item.seq === seq);
        setIsPopupOpen(true);
        setUpdateData(filterData);
    };

    return (
        <>
            <div className="container">
                <div className="wrap">
                    <SideMenu menu={MENU_PAYMENT} />
                    <div className="cancel-payment-content content-right things-to-checkList">
                        <div className="title title-cancel-payment">이용권 관리</div>
                        <div id="cancel-payment-content-list ">
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th>조건 검색</th>
                                        <td>
                                            <div className="flex-conditional-search">
                                                <div className="select-box">
                                                    <select onChange={getSearchCondition} value={searchCondition}>
                                                        <option value="DE_MemberID">덴탈비타민 ID</option>
                                                        <option value="NameKor">이름</option>
                                                        <option value="Ticket_Num">이용권번호</option>
                                                        <option value="GoodName">상품명</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        placeholder="검색어 입력"
                                                        value={keyword}
                                                        onChange={inputChange}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <th style={{ borderBottom: '1px solid #ddd' }}>사용여부</th>
                                        <td>
                                            <div className="flex-CheckGroup">
                                                <CheckGroup
                                                    name="IsUsed"
                                                    options={[
                                                        { id: '전체', value: 'ALL', label: '전체' },
                                                        { id: '사용', value: 'Y', label: '사용' },
                                                        { id: '미사용', value: 'N', label: '미사용' },
                                                    ]}
                                                    checkedValues={checkedValues.IsUsed}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>일자 검색</th>
                                        <td colSpan={3}>
                                            <div className="flex group-item">
                                                <div className="select-box">
                                                    <select
                                                        onChange={getSearchDateCondition}
                                                        value={selectDateCondition}
                                                    >
                                                        <option value="UseDate">사용일</option>
                                                        <option value="PurchaseDate">구매일</option>
                                                        <option value="ExpiryDate">유효기간</option>
                                                    </select>
                                                </div>
                                                <div className="group-datepicker">
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={startDateRef}
                                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={startDate}
                                                            maxDate={endDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="start-date-icon"
                                                            onClick={() => startDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={endDateRef}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={endDate}
                                                            minDate={startDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="end-date-icon"
                                                            onClick={() => endDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                </div>
                                                <ul className="select-value">
                                                    <li
                                                        value-date-range="today"
                                                        className={dateRate === 'today' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        오늘
                                                    </li>
                                                    <li
                                                        value-date-range="1week"
                                                        className={dateRate === '1week' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        일주일
                                                    </li>
                                                    <li
                                                        value-date-range="15days"
                                                        className={dateRate === '15days' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        15일
                                                    </li>
                                                    <li
                                                        value-date-range="1month"
                                                        className={dateRate === '1month' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        1개월
                                                    </li>
                                                    <li
                                                        value-date-range="3months"
                                                        className={dateRate === '3months' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        3개월
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="group-button center">
                                <button className="btn btn-gray-bold" onClick={clickSearch}>
                                    검색
                                </button>
                                <button className="btn btn-gray-thin" onClick={clickReset}>
                                    초기화
                                </button>
                            </div>
                        </div>
                        <div className="results">
                            <div className="flex-top-item">
                                <div className="count-item">
                                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                                </div>
                                <div className="group-button">
                                    <div
                                        className="btn btn-gray-bold"
                                        onClick={() => {
                                            openPopup();
                                        }}
                                    >
                                        개별 이용권 발급
                                    </div>
                                    <div
                                        className="btn btn-gray-bold"
                                        onClick={() => {
                                            handleActivePopup();
                                        }}
                                    >
                                        일괄 이용권 발급
                                    </div>
                                </div>
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>덴탈비타민 ID</th>
                                        <th>이름</th>
                                        <th>덴탈이마트 ID</th>
                                        <th>이용권번호</th>
                                        <th style={{ width: '80px' }}>
                                            사용
                                            <br />
                                            사이트
                                        </th>
                                        <th>상품이름</th>
                                        <th style={{ width: '90px' }}>
                                            판매가격
                                            <br />
                                            결제금액
                                        </th>
                                        <th style={{ width: '110px' }}>
                                            사용/환불여부
                                            <br />
                                            사용/환불일자
                                        </th>
                                        <th>
                                            구매일자
                                            <br />
                                            유효일자
                                        </th>
                                        <th>비고</th>
                                        <th>Comments</th>

                                        <th style={{ width: 50 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ? (
                                        data.map((item) => (
                                            <tr key={item?.seq}>
                                                <td>{item?.seq}</td>
                                                <td>{item?.deMemberID}</td>
                                                <td>{item?.nameKor}</td>
                                                <td>{item?.deMemberID}</td>
                                                <td>{item?.ticketNum}</td>
                                                <td></td>
                                                <td>{item?.goodName}</td>
                                                <td>
                                                    {formatNumberWithCommas(item?.price)}
                                                    <br />
                                                    {formatNumberWithCommas(item?.salePrice)}
                                                </td>
                                                <td>
                                                    {(() => {
                                                        const rawDate =
                                                            item.refundYn === 'Y'
                                                                ? item?.refundDate
                                                                : item?.applDate;

                                                        const isValidDate =
                                                            rawDate &&
                                                            !String(rawDate).startsWith('1900-01-01');

                                                        return (
                                                            <>
                                                                {item.isUsed === 'Y' ? '사용' : '미사용'}
                                                                {isValidDate && (
                                                                    <>
                                                                        <br />
                                                                        {formatDate(rawDate)}
                                                                    </>
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </td>

                                                <td>
                                                    {formatDate(item.purchaseDate)}
                                                    <br />
                                                    {formatDate(item.expiryDate)}
                                                </td>
                                                <td>{item.ticketType}</td>
                                                <td>{item?.comments}</td>

                                                <td style={{ padding: '8px' }}>
                                                    {item?.isUsed === 'N' && (
                                                        <button
                                                            style={{ width: 'max-content', fontSize: '14px' }}
                                                            className="btn btn-gray-thin"
                                                            onClick={() => showPopupUpdate(item?.seq)}
                                                        >
                                                            수정
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={12}>데이타가 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpen && <MAIAA020 closePopup={closePopup} dataPopup={updateData} />}
            {activePopup && <MAIAA030 handleClosePopup={handleClosePopup} />}
        </>
    );
};
export default MAIAA010;
